import { Text } from '@mantine/core';
import { DataTableColumn } from 'mantine-datatable';
import React from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SimpleTable } from 'src/common/components/table/SimpleTable';
import { formatDate } from 'src/financial/financial-data/tables/FinancialItemGenericTable';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import { SuitabilityReportDraftsModal } from './SuitabilityReportDraftsModal';
import { AdminSuitabilityReport } from './types';

type SuitabilityReportsTableProps = {
  company: Company;
};

export function SuitabilityReportsTable({ company }: SuitabilityReportsTableProps) {
  const [selectedId, setSelectedId] = React.useState<string | null>(null);

  const columns: DataTableColumn<AdminSuitabilityReport>[] = [
    {
      accessor: 'id',
      title: 'ID',
      render: (record: AdminSuitabilityReport) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.id}
        </Text>
      ),
    },
    {
      accessor: 'clientId',
      title: 'Client ID',
      render: (record: AdminSuitabilityReport) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.clientId}
        </Text>
      ),
    },
    {
      accessor: 'templateId',
      title: 'Template ID',
      render: (record: AdminSuitabilityReport) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {record.templateId ?? '-'}
        </Text>
      ),
    },
    {
      accessor: 'createdAt',
      title: 'Created at',
      width: 170,
      render: (record: AdminSuitabilityReport) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
          {formatDate(record.createdAt)}
        </Text>
      ),
    },
    {
      accessor: 'markdownPreview',
      title: 'Preview',
      render: (record: AdminSuitabilityReport) => (
        <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10" lineClamp={2}>
          {record.markdownPreview ?? '-'}
        </Text>
      ),
    },
  ];

  return (
    <>
      <SuitabilityReportDraftsModal
        suitabilityReportId={selectedId}
        companyId={company.id}
        onClose={() => setSelectedId(null)}
      />

      <SimpleTable<AdminSuitabilityReport>
        mode="server"
        resource={`admin/companies/${company.id}/suitability-reports`}
        title="Suitability reports"
        columns={columns}
        onRowClick={record => setSelectedId(record.id)}
        showCount
      />
    </>
  );
}
